export const _LOCATION = {
    FETCH_LOCATION_REQUEST: 'FETCH_LOCATION_REQUEST',
    FETCH_LOCATION_SUCCESS: 'FETCH_LOCATION_SUCCESS',
    FETCH_LOCATION_FAILURE: 'FETCH_LOCATION_FAILURE'
}